import React, { useCallback } from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import Textarea from '../../customer-form/textarea'
import InputField from '../../customer-form/InputField'
import CheckBox from '../../customer-form/checkbox'

const FormItemWrapper = styled.div`
  width: 100%;

  ${(props) => props.theme.media.min.sm`
    width: ${theme(
      'questionBlock.textareaWrapper.textArea.width',
      '370px'
    )(props)};
  `}

  textarea {
    border: 1px solid
      ${(props) =>
        theme('questionBlock.textArea.borderColor')(props) ||
        theme('forms.colors.border')(props)};
    border-radius: ${theme('questionBlock.textArea.borderRadius')};
    &:focus {
      outline: none;
      border: 1px solid ${theme('forms.colors.activeBorder')};
      box-shadow: ${theme('colors.accentShadow')};
    }
  }
`

const CheckBoxContainer = styled.div`
  width: 100%;
  max-width: 370px;
  text-align: left;

  label {
    /* margin: 25px auto 0px auto; */
    span {
      color: ${theme('colors.link')};
      font-size: ${theme('photoUpload.checkbox.fontSize')};
      text-transform: none;
      letter-spacing: ${theme('photoUpload.checkbox.letterSpacing')};
      font-family: ${theme('typography.paragraph.fontFamily')};
    }
    > div {
      border-color: ${theme('forms.colors.checkboxBorder')};
    }
  }
  ${(props) => props.theme.media.min.sm`
    max-width: 270px;
  `}
  ${(props) => props.theme.media.min.md`
    max-width: 370px;
  `}

  input[type='checkbox']:checked + div {
    border-color: ${theme('forms.colors.checkboxBorder')};
    svg {
      color: ${theme('forms.colors.svgIconColor')};
    }
  }
`

export const FormOptions = ({ options, values, onChange, onBlur }) => {
  const onChangeFormData = useCallback(
    (e, update = false) => {
      const name = e.target.name
      const value = e.target.value
      const newValues = { ...values }
      if (!value) {
        delete newValues[name]
      } else {
        newValues[name] = value
      }
      onChange(newValues, update)
    },
    [values, onChange]
  )

  const onCheckboxChange = useCallback(
    (e) => {
      onChangeFormData(e, true)
    },
    [onChangeFormData]
  )

  return (
    <>
      {options
        .filter((e) => e.contentType === 'FormFieldOption')
        .map((o) => (
          <FormItemWrapper key={o.label}>
            {o.fieldType === 'textarea' && (
              <Textarea
                label={o.label}
                value={values[o.label] || ''}
                name={o.label}
                onChange={onChangeFormData}
                onBlur={onBlur}
              />
            )}
            {o.fieldType === '' && (
              <InputField
                label={o.label}
                value={values[o.label] || ''}
                name={o.label}
                onChange={onChangeFormData}
                onBlur={onBlur}
              />
            )}
            {o.fieldType === 'checkbox' && (
              <CheckBoxContainer>
                <CheckBox
                  label={o.label}
                  value={values[o.label] === o.label ? '' : o.label}
                  name={o.label}
                  checked={values[o.label] === o.label}
                  onChange={onCheckboxChange}
                />
              </CheckBoxContainer>
            )}
          </FormItemWrapper>
        ))}
    </>
  )
}
